import React, { Component } from 'react'
import { getNavItemStyle, getPath, shouldHeaderCollapsedWithNavigation } from './util'
import { NavItemContainer } from './navItem.container'
import { CategoriesContainer } from './Categories.container'

export class NavigationContainer extends Component {
  constructor() {
    super()
    this.state = {
      isOpen: false,
      openTabIndex: null,
      items: [],
    }
  }

  componentWillUpdate(nextProps, nextState) {
    if (document.body) {
      document.body.classList.toggle('no-scroll', nextState.isOpen)
    }
  }

  componentWillUnmount() {
    if (document.body) {
      document.body.classList.remove('no-scroll')
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      shouldHeaderCollapsedWithNavigation(this.props.site) &&
      this.props.shouldShowNavigation !== nextProps.shouldShowNavigation
    ) {
      document.getElementsByClassName('site-header')[0].classList.toggle('collapse')
      document.getElementsByClassName('video-top-anchor')[0].classList.toggle('collapsed')
    }
  }

  closeMenu() {
    this.setState({ isOpen: false, openTabIndex: null })
  }

  manageMenu(navItem, index) {
    if (this.state.isOpen) {
      this.closeMenu()
    } else {
      this.props.mobileNavigationAnalyticsMenuClicked(navItem.analytics, index)
      this.setState({ isOpen: true, items: navItem.items, openTabIndex: index })
    }
  }

  renderCategories() {
    return (
      <CategoriesContainer
        categories={this.state.items}
        isOpen={this.state.isOpen}
        closeMenu={() => this.closeMenu()}
      />
    )
  }

  isLinkNavItemMatch(url) {
    let path = getPath()
    return path !== '/' && url === path
  }

  isMenuNavItemOpen(index, categories) {
    return this.state.isOpen && this.state.openTabIndex == index && categories !== null
  }

  isLinkNavItemSelected(url, categories) {
    return this.isLinkNavItemMatch(url) && categories === null && !this.state.isOpen
  }

  getNavItemBottomBorderStyle(index, url, categories) {
    return this.isMenuNavItemOpen(index, categories) || this.isLinkNavItemSelected(url, categories)
  }

  renderNavigation(navItems) {
    return navItems.map((navItem, index) =>
      <div
        className={[
          getNavItemStyle(navItems.length),
          this.getNavItemBottomBorderStyle(index, navItem.url, navItem.items)
            ? 'nav__item__selected_border'
            : 'nav__item__border',
          navItem.items !== null ? 'nav__item__with_children' : '',
        ].join(' ')}
        key={index}
      >
        <NavItemContainer
          description={navItem.description}
          icon={navItem.icon}
          analytics={navItem.analytics}
          url={navItem.url}
          isHaveCategories={navItem.items !== null ? true : false}
          isOpen={this.state.isOpen && index === this.state.openTabIndex}
          selectedNavItem={getPath()}
          index={index}
          onCategorySelected={() => {
            this.manageMenu(navItem, index)
          }}
        />
      </div>
    )
  }

  render() {
    return (
      <div
        className={`mobile-nav-main-wrapper ${this.props.shouldShowNavigation
          ? 'mobile-nav-main-wrapper__opened'
          : 'mobile-nav-main-wrapper__closed'}`}
      >
        <div className="nav__wrapper">
          {this.renderNavigation(this.props.config)}
        </div>
        {this.renderCategories()}
      </div>
    )
  }
}

NavigationContainer.defaultProps = {
  shouldShowNavigation: true,
  topAdMargin: 0,
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/header/navigation/Navigation.container.js